import { createApp } from 'vue';
import App from './App.vue';
import router from './router';

const app = createApp(App);

app.config.globalProperties.$isEn = true; // Global language state

app.use(router).mount('#app');
